import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import userAuth from '@/cognito/user-auth'
import sessionStrageUtils from '@/lib/sessionStrage/session-strage-utils'
import { handleWindowAlert } from '@/lib/sessionStrage/re-billing-utils'
import { handleSetDocumentHtmlTitle } from '@/lib/common/index'
import { defineObject } from '@/lib/define/use-define'

Vue.use(VueRouter)

const handleUserAuth = async () => {
  const isUserAuth = (await userAuth.isUserAuth()) as any
  if (!isUserAuth.isAllowUser) {
    location.href =
      process.env.VUE_APP_COGNITO_URL +
      '/logout?client_id=' +
      process.env.VUE_APP_CLIENT_ID +
      '&logout_uri=https://accounts.google.com/Logout'
    alert('使用することができません。')
    // location.href = '/'
    return
  }
}

const handleUserAuthReferrerCheck = () => {
  // 離脱防止アラート初期化
  window.onbeforeunload = () => undefined

  // 離脱防止アラート再セット
  window.onbeforeunload = () => handleWindowAlert

  const currentStaff = sessionStrageUtils.handleGetSessionStorage(
    'currentStaff'
  )

  Promise.all([currentStaff])
    .then((currentStaff: any) => {
      currentStaff = currentStaff[0]

      if (
        process.env.NODE_ENV !== 'local' &&
        (!currentStaff ||
          currentStaff.role !== 1 ||
          !document.referrer.match(process.env.VUE_APP_URL))
      ) {
        alert(
          'データを正常に取得できませんでした。時間をおいてからやり直してください。'
        )
        window.close()

        if (!window.closed) {
          location.replace('/login')
        }
        return
      }
    })
    .catch(err => {
      alert(
        'データを正常に取得できませんでした。時間をおいてからやり直してください。'
      )
      window.close()

      if (!window.closed) {
        location.replace('/login')
      }
    })
}

const handleLoginUserAuth = async () => {
  const isUserAuth = (await userAuth.isUserAuth()) as any
  let nextPage = ''
  console.log(isUserAuth)
  if (isUserAuth.isMultipleOffice) {
    sessionStrageUtils.handleSetSessionStorage(
      'selectOfficeArray',
      isUserAuth.officeArray
    )
    nextPage = '/select_office'
  } else {
    nextPage = '/dashboard'
  }

  return nextPage
}

export const handleLineUserAuth = async () => {
  const isUserAuth = (await userAuth.isLineUserAuth()) as any
  if (!isUserAuth.isAllowUser) {
    location.href =
      process.env.VUE_APP_COGNITO_URL +
      '/logout?client_id=' +
      process.env.VUE_APP_CLIENT_ID +
      '&logout_uri=https://accounts.google.com/Logout'
    alert('使用することができません。')
    return
  }
  if (!isUserAuth.isUseLine) {
    alert('使用することができません。タブを閉じます。')
    // タブを閉じる
    window.close()
    return
  }
}

const Login = () => import('@/components/pages/login/index.vue')

const TheContainer = () => import('@/components/TheContainer.vue')

const Auth = () => import('@/components/pages/auth/index.vue')
const selectOffice = () => import('@/components/pages/select_office/index.vue')
const Dashboard = () => import('@/components/pages/dashboard/index.vue')
const alertBlank = () => import('@/components/pages/alertBlank/index.vue')

const StaffCreate = () => import('@/components/pages/staff/create/index.vue')
const StaffList = () => import('@/components/pages/staff/list/index.vue')
const StaffEdit = () => import('@/components/pages/staff/edit/index.vue')
const StaffAttendance = () =>
  import('@/components/pages/staff/attendance/index.vue')

const ChildCreate = () => import('@/components/pages/children/create/index.vue')
const ChildList = () => import('@/components/pages/children/list/index.vue')
const ChildEdit = () => import('@/components/pages/children/edit/index.vue')

const CldBookList = () => import('@/components/pages/cld_book/list/index.vue')
const CldBookEdit = () => import('@/components/pages/cld_book/edit/index.vue')

const BusinessDayCreate = () =>
  import('@/components/pages/business_day/create/index.vue')
const BusinessDayList = () =>
  import('@/components/pages/business_day/list/index.vue')
const BusinessDayEdit = () =>
  import('@/components/pages/business_day/edit/index.vue')

const PickupInfoList = () =>
  import('@/components/pages/pickup_info/list/index.vue')
const PickupInfoDetails = () =>
  import('@/components/pages/pickup_info/details/index.vue')

const CarCreate = () => import('@/components/pages/car/create/index.vue')
const CarList = () => import('@/components/pages/car/list/index.vue')
const CarEdit = () => import('@/components/pages/car/edit/index.vue')

const ActivityList = () => import('@/components/pages/activity/list/index.vue')

const ActivityPlans = () =>
  import('@/components/pages/activity/activity_plans/index.vue')

const AttendanceList = () =>
  import('@/components/pages/attendance/list/index.vue')

const SchoolCreate = () => import('@/components/pages/school/create/index.vue')
const SchoolList = () => import('@/components/pages/school/list/index.vue')
const SchoolEdit = () => import('@/components/pages/school/edit/index.vue')
const SchoolLeaveTime = () =>
  import('@/components/pages/school/leave_time/index.vue')

// 令和6年度報酬改定まとめて実績記録
const NewBulkAchievementsCreate = () =>
  import('@/components/pages/new_bulk_achievements_create/index.vue')

// 旧まとめて実績記録
const BulkAchievementsCreate = () =>
  import('@/components/pages/bulk_achievements_create/index.vue')

// 令和6年度報酬改定Start
const NewClaimCountry = () =>
  import('@/components/pages/new_claim_country/list/index.vue')
const NewClaimCountryChild = () =>
  import('@/components/pages/new_claim_country/children/index.vue')
const NewClaimCountrySummary = () =>
  import('@/components/pages/new_claim_country/summary/index.vue')
const NewClaimCountryUserBurdens = () =>
  import('@/components/pages/new_claim_country/user_burdens/index.vue')
const NewClaimCountrySummaryCompBridge = () =>
  import('@/components/pages/new_claim_country/summary_comp_bridge/index.vue')

// 旧請求
const ClaimCountry = () =>
  import('@/components/pages/claim_country/list/index.vue')
const ClaimCountryChild = () =>
  import('@/components/pages/claim_country/children/index.vue')
const ClaimCountrySummary = () =>
  import('@/components/pages/claim_country/summary/index.vue')
const ClaimCountryUserBurdens = () =>
  import('@/components/pages/claim_country/user_burdens/index.vue')

const ClaimCountrySummaryCompBridge = () =>
  import('@/components/pages/claim_country/summary_comp_bridge/index.vue')

// 令和6年度報酬改定再請求Start
const NewClaimCountryReBilling = () =>
  import('@/components/pages/new_re_billing/list/index.vue')

const NewClaimCountryReBillingAchievements = () =>
  import(
    '@/components/pages/printout/revision_2024/re_billing_achievements/index.vue'
  )

const NewClaimCountryReBillingChild = () =>
  import('@/components/pages/new_re_billing/children/index.vue')

const NewClaimCountryReBillingSummary = () =>
  import('@/components/pages/new_re_billing/summary/index.vue')

const NewClaimCountryReBillingUserBurdens = () =>
  import('@/components/pages/new_re_billing/user_burdens/index.vue')

const NewClaimCountryReBillingParentsChild = () =>
  import('@/components/pages/new_re_billing/parents_details/index.vue')

const NewClaimCountryReBillingParentsProxyChild = () =>
  import('@/components/pages/new_re_billing/parents_proxy_details/index.vue')

// 再請求 Start
const ClaimCountryReBilling = () =>
  import('@/components/pages/re_billing/list/index.vue')

const ClaimCountryReBillingAchievements = () =>
  import('@/components/pages/printout/re_billing_achievements/index.vue')

const ClaimCountryReBillingChild = () =>
  import('@/components/pages/re_billing/children/index.vue')

const ClaimCountryReBillingSummary = () =>
  import('@/components/pages/re_billing/summary/index.vue')

const ClaimCountryReBillingUserBurdens = () =>
  import('@/components/pages/re_billing/user_burdens/index.vue')

const ClaimCountryReBillingParentsChild = () =>
  import('@/components/pages/re_billing/parents_details/index.vue')

const ClaimCountryReBillingParentsProxyChild = () =>
  import('@/components/pages/re_billing/parents_proxy_details/index.vue')

// 再請求 End

// 令和6年度報酬改定保護者請求Start
const NewClaimParentsChild = () =>
  import('@/components/pages/new_parents/details/index.vue')
const NewClaimParentsList = () =>
  import('@/components/pages/new_parents/list/index.vue')
const NewClaimParentsProxyChild = () =>
  import('@/components/pages/new_parents/proxy_details/index.vue')

// 保護者旧請求
const ClaimParentsChild = () =>
  import('@/components/pages/parents/details/index.vue')
const ClaimParentsList = () =>
  import('@/components/pages/parents/list/index.vue')
const ClaimParentsProxyChild = () =>
  import('@/components/pages/parents/proxy_details/index.vue')

const OfficeEdit = () => import('@/components/pages/office/edit/index.vue')

const PrintoutCldBook = () =>
  import('@/components/pages/printout/cld_book/index.vue')

const PrintoutBusinessLog = () =>
  import('@/components/pages/printout/business_log/index.vue')

const PrintoutAchievements = () =>
  import('@/components/pages/printout/achievements/index.vue')

const PrintoutAchievements2024 = () =>
  import('@/components/pages/printout/revision_2024/achievements/index.vue')

const BillingBulkPrint = () =>
  import('@/components/pages/billing_bulk_print/index.vue')

const newBillingBulkPrint = () =>
  import('@/components/pages/new_billing_bulk_print/index.vue')

const optionAgency = () => import('@/components/pages/option/agency/index.vue')
const optionAttendance = () =>
  import('@/components/pages/option/dayrobo_attendance/index.vue')

const ClaimPrice = () => import('@/components/pages/claim/price/index.vue')

const TheLineContainer = () =>
  import('@/components/utility/line/TheContainer.vue')
// const LineChat = () => import('@/components/pages/line/chat/index.vue')
const LineSegment = () => import('@/components/pages/line/segment/index.vue')
const LineHistory = () => import('@/components/pages/line/history/index.vue')
const LineHistoryDetail = () =>
  import('@/components/pages/line/history/detail/index.vue')

const tutoringPlanCldList = () =>
  import('@/components/pages/tutoringPlan/cldList/index.vue')
const tutoringPlanList = () =>
  import('@/components/pages/tutoringPlan/list/index.vue')
const tutoringPlanDetails = () =>
  import('@/components/pages/tutoringPlan/details/index.vue')

const visitTutoringPlanCldList = () =>
  import('@/components/pages/tutoringPlan/visit/cldList/index.vue')
const visitTutoringPlanList = () =>
  import('@/components/pages/tutoringPlan/visit/list/index.vue')
const visitTutoringPlanDetails = () =>
  import('@/components/pages/tutoringPlan/visit/details/index.vue')
const PrintoutVisitTutoringPlan = () =>
  import('@/components/pages/printout/tutoring_plan/visit/index.vue')

const PrintoutTutoringPlan = () =>
  import('@/components/pages/printout/tutoring_plan/index.vue')

const SpecialSupportPlan = () =>
  import('@/components/pages/printout/special_support_plan/index.vue')

const PrintoutPickupInfo = () =>
  import('@/components/pages/printout/pickup_info/index.vue')

/** デイロボ・クラウド用のルーティング */
const CloudOffice = () => import('@/components/pages/cloud/office/index.vue')
const CloudHistory = () => import('@/components/pages/cloud/history/index.vue')

/** メモ機能のルーティング */
const MemoContainer = () => import('@/components/utility/memo/TheContainer.vue')
const Memo = () => import('@/components/pages/memo/index.vue')

/** 専門的支援計画のルーティング */
const SpecialSupportPlanList = () =>
  import('@/components/pages/special_support_plan/index.vue')
const specialSupportPlanListId = () =>
  import('@/components/pages/special_support_plan/[child_id].vue')
const specialSupportPlanDetailsNewCreate = () =>
  import('@/components/pages/special_support_plan/details/index.vue')
const specialSupportPlanDetails = () =>
  import('@/components/pages/special_support_plan/details/[id].vue')

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    beforeEnter: async (to, from, next) => {
      const nextPage = await handleLoginUserAuth()
      next(nextPage)
    },
  },
  {
    path: '/select_office',
    name: 'selectOffice',
    component: selectOffice,
  },
  {
    path: '/dashboard',
    name: 'ダッシュボード',
    redirect: '/dashboard',
    component: TheContainer,
    children: [
      {
        path: '/dashboard',
        component: Dashboard,

        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
    ],
  },
  {
    path: '/memo',
    name: 'メモ',
    redirect: '/memo',
    component: MemoContainer,
    children: [
      {
        path: '/memo',
        component: Memo,

        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
    ],
  },
  {
    path: '/dashboard',
    redirect: '/dashboard',
    component: TheContainer,

    children: [
      {
        path: '/staff',
        redirect: '/staff/list',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/staff/create',
            name: 'スタッフ登録',
            component: StaffCreate,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/staff/list',
            name: 'スタッフ一覧',
            component: StaffList,

            beforeEnter: async (to, from, next) => {
              if (
                !sessionStrageUtils.handleGetSessionStorage('storedStaffList')
              ) {
                await handleUserAuth()
              }

              next()
            },
          },
          {
            path: '/staff/list',
            name: 'スタッフ一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/staff/edit',
                name: 'スタッフ編集',
                component: StaffEdit,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
        ],
      },
      {
        path: '/children',
        redirect: '/children/list',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/children/create',
            name: '児童仮登録',
            component: ChildCreate,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '児童一覧',
            component: ChildList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/children/edit',
                name: '児童情報編集',
                component: ChildEdit,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/tutoringPlan/cldList',
            name: '個別支援計画の児童一覧',
            component: tutoringPlanCldList,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/tutoringPlan/cldList',
            name: '個別支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/tutoringPlan/list',
                name: '個別支援計画一覧',
                component: tutoringPlanList,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/tutoringPlan/cldList',
            name: '個別支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/tutoringPlan/list',
                name: '個別支援計画一覧',
                component: {
                  render(c) {
                    return c('router-view')
                  },
                },
                children: [
                  {
                    path: '/tutoringPlan/details',
                    name: '個別支援計画詳細',
                    component: tutoringPlanDetails,
                    beforeEnter: async (to, from, next) => {
                      await handleUserAuth()
                      next()
                    },
                  },
                ],
              },
            ],
          },
          {
            path: '/tutoringPlan/visit/cldList',
            name: '【保訪】個別支援計画の児童一覧',
            component: visitTutoringPlanCldList,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/tutoringPlan/visit/cldList',
            name: '【保訪】個別支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/tutoringPlan/visit/list',
                name: '【保訪】個別支援計画一覧',
                component: visitTutoringPlanList,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/tutoringPlan/visit/cldList',
            name: '【保訪】個別支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/tutoringPlan/visit/list',
                name: '【保訪】個別支援計画一覧',
                component: {
                  render(c) {
                    return c('router-view')
                  },
                },
                children: [
                  {
                    path: '/tutoringPlan/visit/details',
                    name: '【保訪】個別支援計画詳細',
                    component: visitTutoringPlanDetails,
                    beforeEnter: async (to, from, next) => {
                      await handleUserAuth()
                      next()
                    },
                  },
                ],
              },
            ],
          },
          {
            path: '/special_support_plan',
            name: '専門的支援計画の児童一覧',
            component: SpecialSupportPlanList,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/special_support_plan',
            name: '専門的支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/special_support_plan/:child_id',
                name: '専門的支援計画一覧',
                component: specialSupportPlanListId,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/special_support_plan',
            name: '専門的支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/special_support_plan/:child_id',
                name: '専門的支援計画一覧',
                component: {
                  render(c) {
                    return c('router-view')
                  },
                },
                children: [
                  {
                    path: '/special_support_plan/:child_id/detail/new_create',
                    name: '専門的支援計画作成',
                    component: specialSupportPlanDetailsNewCreate,
                    beforeEnter: async (to, from, next) => {
                      await handleUserAuth()
                      next()
                    },
                  },
                ],
              },
            ],
          },
          {
            path: '/special_support_plan',
            name: '専門的支援計画の児童一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/special_support_plan/:child_id',
                name: '専門的支援計画一覧',
                component: {
                  render(c) {
                    return c('router-view')
                  },
                },
                children: [
                  {
                    path: '/special_support_plan/:child_id/detail/:id',
                    name: '専門的支援計画詳細',
                    component: specialSupportPlanDetails,
                    beforeEnter: async (to, from, next) => {
                      await handleUserAuth()
                      next()
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/cld_book',
        redirect: '/children/list',
        // name: '連絡帳',
        // beforeEnter: async (to, from, next) => {
        //   await handleUserAuth()
        //   next()
        // },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            name: '連絡帳一覧',
            component: CldBookList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'edit',
            name: '連絡帳編集',
            component: CldBookEdit,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/attendance',
        redirect: '/attendance/list',
        // name: '出欠',
        // beforeEnter: async (to, from, next) => {
        //   await handleUserAuth()
        //   next()
        // },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            name: '出欠一覧',
            component: AttendanceList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          // {
          //   path: 'create',
          //   name: '出欠登録',
          //   component: AttendanceCreate,
          //
          //   beforeEnter: async (to, from, next) => {
          //     await handleUserAuth()
          //     next()
          //   },
          // },
          {
            path: 'shift_list',
            name: 'シフト一覧・編集',
            component: StaffAttendance,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          // {
          //   path: 'edit',
          //   name: 'CldBookEdit',
          //   component: CldBookEdit,
          // },
        ],
      },
      {
        path: '/business_day',
        redirect: '/business_day/list',
        // name: '営業日',
        // beforeEnter: async (to, from, next) => {
        //   await handleUserAuth()
        //   next()
        // },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'create',
            name: '営業日登録',
            component: BusinessDayCreate,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '営業日一覧',
            component: BusinessDayList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'edit',
            name: '営業日編集',
            component: BusinessDayEdit,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/pickup_info',
        redirect: '/pickup_info/list',
        // name: '送迎一覧',
        // beforeEnter: async (to, from, next) => {
        //   await handleUserAuth()
        //   next()
        // },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/pickup_info/list',
            name: '送迎',
            component: PickupInfoList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/pickup_info/list',
            name: '送迎',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/pickup_info/details',
                name: '送迎編集',
                component: PickupInfoDetails,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
        ],
      },
      {
        path: '/car',
        redirect: '/car/list',
        name: '車',
        // beforeEnter: async (to, from, next) => {
        //   await handleUserAuth()
        //   next()
        // },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'create',
            name: '車登録',
            component: CarCreate,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '車一覧',
            component: CarList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'edit',
            name: '車編集',
            component: CarEdit,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/activity',
        redirect: '/activity/list',
        // name: '活動管理',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            name: '活動名一覧',
            component: ActivityList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'activity_plans',
            name: '活動予定一覧',
            component: ActivityPlans,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/school',
        redirect: '/school/list',
        // name: '学校',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/school/create',
            name: '学校登録',
            component: SchoolCreate,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/school/list',
            name: '学校一覧',
            component: SchoolList,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/school/list',
            name: '学校一覧',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/school/edit',
                name: '学校編集',
                component: SchoolEdit,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/school/leave_time',
                name: '下校時刻',
                component: SchoolLeaveTime,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
        ],
      },
      // {
      //   path: '/claim',
      //   redirect: '/claim/list',
      //   name: '福祉ソフトでの請求管理',
      //   // beforeEnter: async (to, from, next) => {
      //   //   await handleUserAuth()
      //   //   next()
      //   // },
      //   component: {
      //     render(c) {
      //       return c('router-view')
      //     },
      //   },
      //   children: [
      //     {
      //       path: 'create',
      //       name: '請求データ作成',
      //       component: ClaimCreate,
      //
      //       beforeEnter: async (to, from, next) => {
      //         await handleUserAuth()
      //         next()
      //       },
      //     },
      //     {
      //       path: 'list',
      //       name: '請求データ一覧',
      //       component: ClaimList,
      //
      //       beforeEnter: async (to, from, next) => {
      //         await handleUserAuth()
      //         next()
      //       },
      //     },
      //   ],
      // },
      {
        path: '/claim_country',
        redirect: '/claim_country/list',
        // name: '【令和3年度版】国保連ソフトでの請求管理',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/claim_country/list',
            name: '【令和3年度版】請求データ作成',
            component: ClaimCountry,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/list',
            name: '【令和3年度版】請求データ作成',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/claim_country/children',
                name: '障害児通所給付費・入所給付費等請求書（様式第二）作成',
                component: ClaimCountryChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  await handleUserAuthReferrerCheck()
                  next()
                },
              },
              {
                path: '/claim_country/summary',
                name: '障害児通所給付費・入所給付費等請求書（様式第一）作成',
                component: ClaimCountrySummary,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/claim_country/summary_comp_bridge/',
                name: '様式第一から請求TOPリダイレクト',
                component: ClaimCountrySummaryCompBridge,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/claim_country/user_burdens',
                name: '利用者負担額一覧表',
                component: ClaimCountryUserBurdens,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/claim_country/achievements/printout',
                name: '実績記録',
                component: PrintoutAchievements,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/claim_country/bulk_print/',
            name: '請求データ作成　まとめて印刷',
            component: BillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/',
            name: '再請求・返戻データ作成',
            component: ClaimCountryReBilling,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/printout/re_billing_achievements/',
            name: '再請求・返戻データ作成（CSV） 実績記録',
            component: ClaimCountryReBillingAchievements,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/bulk_print/',
            name: '再請求・返戻データ作成（CSV）　まとめて印刷',
            component: BillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/children/',
            name:
              '再請求・返戻データ作成（CSV） 障害児通所給付費・入所給付費等請求書（様式第二）作成',
            component: ClaimCountryReBillingChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/summary/',
            name:
              '再請求・返戻データ作成（CSV） 障害児通所給付費・入所給付費等請求書（様式第一）作成',
            component: ClaimCountryReBillingSummary,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/summary_comp_bridge/',
            name:
              '再請求・返戻データ作成（CSV） 様式第一から請求TOPリダイレクト',
            component: ClaimCountrySummaryCompBridge,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/user_burdens/',
            name: '再請求・返戻データ作成（CSV） 利用者負担額一覧表',
            component: ClaimCountryReBillingUserBurdens,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/parents_details/',
            name: '再請求・返戻データ作成（CSV） 利用料明細 / 請求書・領収書',
            component: ClaimCountryReBillingParentsChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing/parents_proxy_details/',
            name: '再請求・返戻データ作成（CSV） 代理受領額通知書',
            component: ClaimCountryReBillingParentsProxyChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/achievements/printout',
            name: '再請求・返戻データ作成 実績記録',
            component: PrintoutAchievements,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/bulk_print',
            name: '再請求・返戻データ作成　まとめて印刷',
            component: BillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/children/',
            name:
              '再請求・返戻データ作成 障害児通所給付費・入所給付費等請求書（様式第二）作成',
            component: ClaimCountryChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/summary/',
            name:
              '再請求・返戻データ作成　障害児通所給付費・入所給付費等請求書（様式第一）作成',
            component: ClaimCountrySummary,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/summary_comp_bridge/',
            name: '再請求・返戻データ作成 様式第一から請求TOPリダイレクト',
            component: ClaimCountrySummaryCompBridge,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/user_burdens/',
            name: '再請求・返戻データ作成　利用者負担額一覧表',
            component: ClaimCountryUserBurdens,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/parents_details/',
            name: '再請求・返戻データ作成　利用料明細 / 請求書・領収書',
            component: ClaimParentsChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/claim_country/re_billing_stored/parents_proxy_details/',
            name: '再請求・返戻データ作成　代理受領額通知書',
            component: ClaimParentsProxyChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/new_claim_country',
        redirect: '/new_claim_country/list',
        // name: '【令和6年度版】国保連ソフトでの請求管理',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: '/new_claim_country/list',
            name: '【令和6年度版】請求データ作成',
            component: NewClaimCountry,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/list',
            name: '【令和6年度版】請求データ作成',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/new_claim_country/children',
                name: '障害児通所給付費・入所給付費等請求書（様式第二）作成',
                component: NewClaimCountryChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  await handleUserAuthReferrerCheck()
                  next()
                },
              },
              {
                path: '/new_claim_country/user_burdens',
                name: '利用者負担額一覧表',
                component: NewClaimCountryUserBurdens,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/new_claim_country/summary',
                name: '障害児通所給付費・入所給付費等請求書（様式第一）作成',
                component: NewClaimCountrySummary,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/new_claim_country/summary_comp_bridge/',
                name: '様式第一から請求TOPリダイレクト',
                component: NewClaimCountrySummaryCompBridge,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
              {
                path: '/new_claim_country/achievements/printout',
                name: '実績記録',
                component: PrintoutAchievements2024,
                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
          {
            path: '/new_claim_country/bulk_print/',
            name: '請求データ作成　まとめて印刷',
            component: newBillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/',
            name: '再請求・返戻データ作成',
            component: NewClaimCountryReBilling,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/printout/new_re_billing_achievements/',
            name: '再請求・返戻データ作成（CSV） 実績記録',
            component: NewClaimCountryReBillingAchievements,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/achievements/printout',
            name: '再請求・返戻データ作成 実績記録',
            component: PrintoutAchievements2024,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/bulk_print',
            name: '再請求・返戻データ作成　まとめて印刷',
            component: newBillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/bulk_print/',
            name: '再請求・返戻データ作成（CSV）　まとめて印刷',
            component: BillingBulkPrint,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/children/',
            name:
              '再請求・返戻データ作成（CSV） 障害児通所給付費・入所給付費等請求書（様式第二）作成',
            component: NewClaimCountryReBillingChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/summary/',
            name:
              '再請求・返戻データ作成（CSV） 障害児通所給付費・入所給付費等請求書（様式第一）作成',
            component: NewClaimCountryReBillingSummary,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/summary_comp_bridge/',
            name:
              '再請求・返戻データ作成（CSV） 様式第一から請求TOPリダイレクト',
            component: NewClaimCountrySummaryCompBridge,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/user_burdens/',
            name: '再請求・返戻データ作成（CSV） 利用者負担額一覧表',
            component: NewClaimCountryReBillingUserBurdens,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/parents_details/',
            name: '再請求・返戻データ作成（CSV） 利用料明細 / 請求書・領収書',
            component: NewClaimCountryReBillingParentsChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing/parents_proxy_details/',
            name: '再請求・返戻データ作成（CSV） 代理受領額通知書',
            component: NewClaimCountryReBillingParentsProxyChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/children/',
            name:
              '再請求・返戻データ作成 障害児通所給付費・入所給付費等請求書（様式第二）作成',
            component: NewClaimCountryChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/summary/',
            name:
              '再請求・返戻データ作成　障害児通所給付費・入所給付費等請求書（様式第一）作成',
            component: NewClaimCountrySummary,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/summary_comp_bridge/',
            name: '再請求・返戻データ作成 様式第一から請求TOPリダイレクト',
            component: NewClaimCountrySummaryCompBridge,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/user_burdens/',
            name: '再請求・返戻データ作成　利用者負担額一覧表',
            component: NewClaimCountryUserBurdens,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/parents_details/',
            name: '再請求・返戻データ作成　利用料明細 / 請求書・領収書',
            component: NewClaimParentsChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              await handleUserAuthReferrerCheck()
              next()
            },
          },
          {
            path: '/new_claim_country/re_billing_stored/parents_proxy_details/',
            name: '再請求・返戻データ作成　代理受領額通知書',
            component: NewClaimParentsProxyChild,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/bulk_achievements_create',
        redirect: '/bulk_achievements_create/list',
        name: '実績記録まとめて作成・編集',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            component: BulkAchievementsCreate,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'achievements/printout',
            name: '実績記録',
            component: PrintoutAchievements,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/new_bulk_achievements_create',
        redirect: '/new_bulk_achievements_create/list',
        name: '【令和6年度版】実績記録まとめて作成・編集',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            component: NewBulkAchievementsCreate,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'achievements/printout',
            name: '実績記録',
            component: PrintoutAchievements2024,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/parents',
        redirect: '/parents/list',
        // name: '保護者請求管理',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            name: '【令和3年度版】保護者請求データ作成',
            component: ClaimParentsList,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '【令和3年度版】保護者請求データ作成',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/parents/children',
                name: '利用料明細 / 請求書・領収書',
                component: ClaimParentsChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  await handleUserAuthReferrerCheck()
                  next()
                },
              },
              {
                path: '/parents/proxy_children',
                name: '代理受領額通知書',
                component: ClaimParentsProxyChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
        ],
      },
      {
        path: '/new_parents',
        redirect: '/new_parents/list',
        // name: '【令和6年度版】保護者請求管理',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'list',
            name: '【令和6年度版】保護者請求データ作成',
            component: NewClaimParentsList,
            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'list',
            name: '【令和6年度版】保護者請求データ作成',
            component: {
              render(c) {
                return c('router-view')
              },
            },
            children: [
              {
                path: '/new_parents/children',
                name: '利用料明細 / 請求書・領収書',
                component: NewClaimParentsChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  await handleUserAuthReferrerCheck()
                  next()
                },
              },
              {
                path: '/new_parents/proxy_children',
                name: '代理受領額通知書',
                component: NewClaimParentsProxyChild,

                beforeEnter: async (to, from, next) => {
                  await handleUserAuth()
                  next()
                },
              },
            ],
          },
        ],
      },

      {
        path: '/office',
        redirect: '/office/edit',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'edit',
            name: '事業所',
            component: OfficeEdit,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },

      {
        path: '/cld_book/printout',
        name: '連絡帳印刷',
        component: PrintoutCldBook,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
      {
        path: '/business_log/printout',
        name: '業務日誌印刷',
        component: PrintoutBusinessLog,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
      {
        path: '/info',
        redirect: '/info/price',
        // name: 'ご利用情報',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'price',
            name: 'ご利用料金等',
            component: ClaimPrice,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      // デイロボ・クラウド
      {
        path: '/cloud',
        redirect: '/cloud/office',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'office',
            name: '事業所に関する資料',
            component: CloudOffice,
            beforeEnter: async (_, __, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'history',
            name: '操作履歴',
            component: CloudHistory,
            beforeEnter: async (_, __, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/option',
        redirect: '/option/agency',
        // name: 'オプションサービス',
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'agency',
            name: '児童登録代行サービス',
            component: optionAgency,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
          {
            path: 'dayrobo_attendance',
            name: `${defineObject.APP_INFO.appName}勤怠`,
            component: optionAttendance,

            beforeEnter: async (to, from, next) => {
              await handleUserAuth()
              next()
            },
          },
        ],
      },
      {
        path: '/tutoring_plan/printout',
        name: '個別支援計画印刷',
        component: PrintoutTutoringPlan,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
      {
        path: '/tutoring_plan/printout/visit',
        name: '【保訪】個別支援計画印刷',
        component: PrintoutVisitTutoringPlan,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
      {
        path: '/special_support_plan/print/:id',
        name: '専門的支援計画印刷',
        component: SpecialSupportPlan,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
      {
        path: '/pickup_info/printout',
        name: '送迎表印刷',
        component: PrintoutPickupInfo,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
    ],
  },
  {
    path: '/line',
    name: `${defineObject.APP_INFO.appName}LINE plus`,
    redirect: '/line/segment',
    component: TheLineContainer,
    children: [
      {
        path: 'segment',
        name: '一斉配信',
        component: LineSegment,

        beforeEnter: async (to, from, next) => {
          await handleLineUserAuth()
          next()
        },
      },
      {
        path: 'history',
        name: '配信履歴',
        component: LineHistory,

        beforeEnter: async (to, from, next) => {
          await handleLineUserAuth()
          next()
        },
      },
      {
        path: 'history/detail',
        name: '配信履歴の詳細',
        component: LineHistoryDetail,

        beforeEnter: async (to, from, next) => {
          await handleLineUserAuth()
          next()
        },
      },
      {
        path: 'alertBlank',
        name: 'アラート用ブランク',
        component: alertBlank,
        beforeEnter: async (to, from, next) => {
          await handleUserAuth()
          next()
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // 望みのポジションを返す
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes,
})

router.beforeEach((to, from, next) => {
  const printSizeStyle = document.getElementById('print-size-style')

  if (printSizeStyle) {
    printSizeStyle.remove()
  }

  const style = document.createElement('style')

  style.setAttribute('id', 'print-size-style')

  if (String(to.path).match(/attendance/)) {
    style.textContent = `
        @page {
          size: A4 landscape !important;
          margin: auto;
        }`
  } else {
    style.textContent = `
        @page {
          size: A4 portrait !important;
          margin: auto;
        }
      `
  }

  document.head.appendChild(style)

  switch (to.path) {
    case '/':
    case '/login':
    case '/auth':
    case '/select_office':
      sessionStrageUtils.handleRemoveSessionStorage('oemInfo')
      break
  }

  handleSetDocumentHtmlTitle()

  next()
})

export default router
